/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '#primary-nav' ).slideToggle();
      } );

      $( '.search-trigger' ).on( 'toggleAfter', ( event ) => {
        $( '#search-area' ).slideToggle();
      } );

      $( '.js-init-product-search' ).magnificPopup( {
        items: {
          src: '#product-search-popup',
        },
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      // if ( window.innerWidth > 768 ) {
      //   $( '.primary-menu-item:first-child button' ).addClass( 'is-open' ).attr( 'aria-expanded', 'true' );
      //   $( '.dropdown-menu:first-child' ).addClass( 'is-open' ).attr( 'aria-hidden', 'false' );
      // }

      $( '.primary-menu-item button' ).on( 'click', function() {
        const dropdown = $( this ).attr( 'data-dropdown' );
        const mobileDropdown = $( this ).attr( 'data-mobile-dropdown' );
        $( '.primary-menu-item button' ).attr( 'aria-expanded', $( this ).attr( 'aria-expanded' ) == 'true' ? 'false' : 'true' );
        $( '.primary-menu-item button' ).not( this ).removeClass( 'is-open' );
        $( this ).toggleClass( 'is-open' );

        if ( window.innerWidth > 768 ) {
          $( '.dropdown-menu' ).attr( 'aria-hidden', $( dropdown ).attr( 'aria-hidden' ) == 'true' ? 'false' : 'true' );
          $( '.dropdown-menu' ).not( dropdown ).removeClass( 'is-open' );
          $( dropdown ).toggleClass( 'is-open' );
        } else {
          $( '.dropdown-menu--mobile' ).attr( 'aria-hidden', $( mobileDropdown ).attr( 'aria-hidden' ) == 'true' ? 'false' : 'true' );
          $( '.dropdown-menu--mobile' ).not( mobileDropdown ).removeClass( 'is-open' );
          $( mobileDropdown ).toggleClass( 'is-open' );
        }
      } );

      if ( $( '.navbar .announcement-banner' ).length && !localStorage.getItem( 'feHideAnnouncement' ) ) {
        $( '.announcement-banner' ).show();
        const root = document.querySelector( ':root' );
        const navbarHeight = parseInt( getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' ) );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const announcementBannerHeight = parseInt( $( '.navbar .announcement-banner' ).outerHeight() );

        const newNavbarHeight = ( navbarHeight + announcementBannerHeight ) + 'px';
        const newTopOffset = topOffset.slice( 0, -1 ) + ' + ' + announcementBannerHeight + 'px)';

        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        root.style.setProperty( '--announcementBannerHeight', announcementBannerHeight + 'px' );
      }

      $( '.announcement-banner .close' ).on( 'click', function() {
        const root = document.querySelector( ':root' );
        const navbarHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--navbarHeight' );
        const topOffset = getComputedStyle( document.documentElement ).getPropertyValue( '--topOffset' );
        const announcementBannerHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--announcementBannerHeight' );

        const newNavbarHeight = ( parseInt( navbarHeight ) - parseInt( announcementBannerHeight ) ) + 'px';
        const newTopOffset = topOffset.replace( ' + ' + parseInt( announcementBannerHeight ) + 'px', '' );

        $( '.announcement-banner' ).remove();
        root.style.setProperty( '--announcementBannerHeight', '0px' );
        root.style.setProperty( '--navbarHeight', newNavbarHeight );
        root.style.setProperty( '--topOffset', newTopOffset );
        localStorage.setItem( 'feHideAnnouncement', true );
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
